import { NgModule } from '@angular/core';
import { HTTP_CONFIG, HttpModule } from '@partners/http';
import { CommonHttpConfig } from './config/http.config';

@NgModule({
  imports: [
    HttpModule.forRoot({
      provide: HTTP_CONFIG,
      useClass: CommonHttpConfig
    })
  ]
})
export class HttpCommonModule {}
